import React from 'react';

/**
 * Returns true when the store has been marked closed/inactive.
 * Centralized so all store views agree on the heuristic.
 */
export function isStoreClosed(store) {
    if (!store) return false;
    const status = (store.status || '').toLowerCase();
    return (
        status === 'closed' ||
        status === 'inactive' ||
        status === 'disabled' ||
        store.is_active === false ||
        store.open === false
    );
}

/**
 * Prominent banner shown when the store is closed. Renders nothing if open.
 */
export function StoreClosedBanner({ store }) {
    if (!isStoreClosed(store)) return null;
    const message =
        store.closed_message ||
        store.closure_message ||
        store.status_message ||
        store.close_reason ||
        'החנות סגורה כרגע ולא ניתן לבצע הזמנות.';

    return (
        <div className="max-w-5xl mx-auto px-4 pt-4">
            <div className="relative overflow-hidden rounded-xl bg-danger-500 text-ink-inverse p-6 shadow-elevated border border-danger-600/30">
                <div className="absolute inset-0 opacity-20 pointer-events-none bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.35),transparent_60%)]" />
                <h2 className="heading-lg text-ink-inverse mb-2">החנות סגורה</h2>
                <p className="text-white/95 leading-relaxed whitespace-pre-line font-medium mb-3">
                    {message}
                </p>
                <p className="font-semibold text-white/90 text-sm flex items-center gap-2">
                    <span className="inline-block bg-white/15 backdrop-blur px-3 py-1 rounded-pill border border-white/20">
                        הזמנות אינן זמינות
                    </span>
                </p>
            </div>
        </div>
    );
}

export default StoreClosedBanner;
